import { ISubtitleInfo } from '../interfaces/advanced-table.interface'

export interface IReturnLabel {
  path: string
  text: string
  /** Match any path under `path` (detail pages with an id segment). */
  prefix?: boolean
}

/**
 * Back link for the page a drill-down came from. `returnUrl` is that page's path, optionally with its
 * `?filters=<token>` so the back link restores its filters. Labels match on the path only.
 */
export function resolveReturnLink(
  returnUrl: string | undefined,
  labels: IReturnLabel[]
): ISubtitleInfo | undefined {
  if (!returnUrl) {
    return undefined
  }
  const [path, queryString] = returnUrl.split('?')
  const label = labels.find((l) => (l.prefix ? path.startsWith(l.path) : path === l.path))
  if (!label) {
    return undefined
  }
  const filters = queryString ? new URLSearchParams(queryString).get('filters') : null
  return {
    text: label.text,
    icon: 'arrow-back',
    link: path,
    queryParams: filters ? { filters } : undefined
  }
}
